import { useEffect, useState } from 'react';

const useProgress = (
  inProgress: boolean,
  finished: boolean,
  delay?: number,
) => {
  const [progress, setProgress] = useState(0);
  const progressDelay = delay || 600;
  useEffect(() => {
    const progressInterval = setInterval(() => {
      if(inProgress){
        if(progress <= 98){
          setProgress(progress + 1);
        }
        if(progress > 98){
          clearInterval(progressInterval);
        }
      }
      if(finished){
        clearInterval(progressInterval);
        setProgress(0);
      }
    }, progressDelay);
    return () => {
      clearInterval(progressInterval);
    };
  }, [inProgress, progress]);

  return {progress};
};

export default useProgress;
